// extracted by mini-css-extract-plugin
export default {"quotePublishContainer":"styles_quotePublishContainer__P2KMr","button":"styles_button__LagLq"};